import { apiFetch } from '@/shared/api/apiFetch';
import { positionsResponseSchema, type PositionsResponse } from '../model/positionSchema';

export type PositionsParams = {
  q?: string;
  is_active?: boolean;
  page_token?: string;
};

/** GET /v1/positions — справочник должностей (для фильтра в списке сотрудников). */
export async function fetchPositions(params: PositionsParams = {}): Promise<PositionsResponse> {
  const sp = new URLSearchParams();
  if (params.q) sp.set('q', params.q);
  if (params.is_active !== undefined) sp.set('is_active', String(params.is_active));
  if (params.page_token) sp.set('page_token', params.page_token);
  const qs = sp.toString();
  const json = await apiFetch<unknown>(`/positions${qs ? `?${qs}` : ''}`, { method: 'GET' });
  return positionsResponseSchema.parse(json);
}
